module.exports = __webpack_public_path__ + "img/loginAvatar.728a9357.svg";